var _style, _text, _style2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplyCornerDataLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 280 245",
    preserveAspectRatio: "xMidYMid",
    style: {
      display: "block",
      shapeRendering: "auto",
      background: "transparent"
    },
    width: 280,
    height: 245,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .ld-text text {\n    text-anchor: middle;\n    dominant-baseline: middle;\n    font-size: 22px;\n    opacity: 0;\n    user-select: none;\n    pointer-events: none;\n  }\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "140px 122.5px",
      transform: "scale(1)"
    },
    className: "ld-text"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,122.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2750) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -1.13684s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-369px -10.13px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 34.93L26 34.93Q30 34.93 33.08 32.77Q36.16 30.61 36.16 26.25Q36.16 21.89 32.84 19.57Q29.52 17.25 23.40 15.53Q17.28 13.81 14.52 12.53Q11.76 11.25 9.28 9.17L9.28 9.17Q4.32 5.01 4.32-3.71L4.32-3.71Q4.32-10.83 9.40-15.95Q14.48-21.07 23.28-21.07L23.28-21.07Q27.52-21.07 32.12-19.83Q36.72-18.59 37.84-18.59Q38.96-18.59 39.84-20.19L39.84-20.19L40.72-20.19L41.28-4.03L40-4.03Q36.16-10.99 31.96-15.19Q27.76-19.39 22.84-19.39Q17.92-19.39 15.20-17.11Q12.48-14.83 12.48-11.03Q12.48-7.23 15.72-5.19Q18.96-3.15 23.68-1.87Q28.40-0.59 29.88-0.11Q31.36 0.37 33.56 1.21Q35.76 2.05 37.16 2.97Q38.56 3.89 40.12 5.29Q41.68 6.69 42.56 8.37L42.56 8.37Q44.72 12.21 44.72 17.49L44.72 17.49Q44.72 26.13 39.32 31.37Q33.92 36.61 25.12 36.61L25.12 36.61Q20.56 36.61 14.68 35.41Q8.80 34.21 8.16 34.21L8.16 34.21Q7.04 34.21 6 36.61L6 36.61L4.88 36.61L4.08 17.57L5.44 17.57Q8.96 24.53 14.44 29.73Q19.92 34.93 26 34.93",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -1.07368s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-322.24px -0.74px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.80 34.37L94.80 35.81L76.56 35.81L75.68 29.97Q74.40 33.17 71.88 34.89Q69.36 36.61 64.40 36.61L64.40 36.61Q52 36.61 52 23.25L52 23.25L52-0.83L47.52-0.83L47.52-2.27L66.88-2.27L66.88 25.17Q66.88 29.97 67.56 31.49Q68.24 33.01 70.28 33.01Q72.32 33.01 73.92 30.53Q75.52 28.05 75.52 23.65L75.52 23.65L75.52-0.83L71.84-0.83L71.84-2.27L90.40-2.27L90.40 34.37L94.80 34.37",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -1.01053s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-274.68px 7.98px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.60 14.29Q125.60 6.05 124.80 3.21Q124 0.37 121.68 0.37Q119.36 0.37 117.52 3.37Q115.68 6.37 115.68 11.41L115.68 11.41L115.68 26.05Q115.68 29.49 117.04 31.89Q118.40 34.29 121.04 34.29Q123.68 34.29 124.64 30.77Q125.60 27.25 125.60 18.45L125.60 18.45L125.60 14.29 zM96.56-2.27L115.52-2.27L115.52 4.05Q118.64-3.07 126.56-3.07L126.56-3.07Q133.44-3.07 137.24 1.89Q141.04 6.85 141.04 16.93Q141.04 27.01 136.92 31.81Q132.80 36.61 124.56 36.61L124.56 36.61Q120.72 36.61 118.80 35.65Q116.88 34.69 115.68 32.69L115.68 32.69L115.68 53.41L126 53.41L126 54.85L96.40 54.85L96.40 53.41L100.80 53.41L100.80-0.83L96.56-0.83L96.56-2.27",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.947368s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-227.64px 7.98px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.64 14.29Q172.64 6.05 171.84 3.21Q171.04 0.37 168.72 0.37Q166.40 0.37 164.56 3.37Q162.72 6.37 162.72 11.41L162.72 11.41L162.72 26.05Q162.72 29.49 164.08 31.89Q165.44 34.29 168.08 34.29Q170.72 34.29 171.68 30.77Q172.64 27.25 172.64 18.45L172.64 18.45L172.64 14.29 zM143.60-2.27L162.56-2.27L162.56 4.05Q165.68-3.07 173.60-3.07L173.60-3.07Q180.48-3.07 184.28 1.89Q188.08 6.85 188.08 16.93Q188.08 27.01 183.96 31.81Q179.84 36.61 171.60 36.61L171.60 36.61Q167.76 36.61 165.84 35.65Q163.92 34.69 162.72 32.69L162.72 32.69L162.72 53.41L173.04 53.41L173.04 54.85L143.44 54.85L143.44 53.41L147.84 53.41L147.84-0.83L143.60-0.83L143.60-2.27",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.884211s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-191.2px -12.09px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.16-22.75L190.16-24.19L209.76-24.19L209.76 34.37L214.24 34.37L214.24 35.81L190.48 35.81L190.48 34.37L194.88 34.37L194.88-22.75L190.16-22.75",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.821053s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-157.96px 8.86px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.44-0.83L214.16-0.83L214.16-2.27L237.36-2.27L237.36-0.83L233.04-0.83L241.76 25.73L251.04-0.83L245.68-0.83L245.68-2.27L256.96-2.27L256.96-0.83L252.96-0.83L238 42.29Q235.36 49.81 232.08 52.81Q228.80 55.81 224.08 55.81Q219.36 55.81 216.64 53.65Q213.92 51.49 213.92 48.13Q213.92 44.77 215.68 43.01Q217.44 41.25 220.32 41.25L220.32 41.25Q226.96 41.25 226.96 46.77L226.96 46.77Q226.96 47.97 226.48 49.65L226.48 49.65L223.68 49.65Q223.04 51.49 223.52 52.69Q224 53.89 225.68 53.89L225.68 53.89Q228.96 53.89 231.52 50.65Q234.08 47.41 236.40 40.77L236.40 40.77L238.16 35.81L231.12 35.81L217.44-0.83",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.757895s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-95.96px -10.13px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.72-19.47L302.72-19.47Q290.32-19.47 290.32 4.45L290.32 4.45L290.32 10.77Q290.32 22.13 293.60 28.57Q296.88 35.01 303.28 35.01L303.28 35.01Q312.08 35.01 319.44 17.89L319.44 17.89L320.88 17.89L320.32 35.73L319.44 35.73Q318.96 34.85 318.56 34.49Q318.16 34.13 317.40 34.13Q316.64 34.13 311.60 35.37Q306.56 36.61 301.36 36.61L301.36 36.61Q288.32 36.61 281.16 29.57Q274 22.53 274 8.41Q274-5.71 281.48-13.39Q288.96-21.07 301.60-21.07L301.60-21.07Q306.48-21.07 311.16-19.83Q315.84-18.59 316.64-18.59Q317.44-18.59 317.84-18.95Q318.24-19.31 318.72-20.19L318.72-20.19L319.60-20.19L320.24-2.83L318.80-2.83Q315.20-10.91 311.40-15.19Q307.60-19.47 302.72-19.47",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.694737s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-46.56px -1.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.76 20.05L351.76 20.05L351.76 13.25Q351.76 5.49 350.92 1.93Q350.08-1.63 347.04-1.63L347.04-1.63Q345.28-1.63 344.20-0.63Q343.12 0.37 342.64 2.69L342.64 2.69Q341.92 6.29 341.92 13.65L341.92 13.65L341.92 19.89Q341.92 28.61 342.44 30.37Q342.96 32.13 343.52 33.25L343.52 33.25Q344.40 35.17 346.96 35.17L346.96 35.17Q350.08 35.17 351.04 31.57L351.04 31.57Q351.76 29.01 351.76 20.05 zM346.80 36.61Q336.80 36.61 331.68 31.49Q326.56 26.37 326.56 16.81Q326.56 7.25 332.04 2.09Q337.52-3.07 347.44-3.07Q357.36-3.07 362.24 1.69Q367.12 6.45 367.12 16.21L367.12 16.21Q367.12 36.61 346.80 36.61L346.80 36.61",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.631579s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "-4.8px -1.53px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.08-0.03L396.08-0.03Q393.12-0.03 390.88 3.81Q388.64 7.65 388.64 12.93L388.64 12.93L388.64 34.37L394.32 34.37L394.32 35.81L369.36 35.81L369.36 34.37L373.76 34.37L373.76-0.83L369.36-0.83L369.36-2.27L388.64-2.27L388.64 5.41Q389.68 1.33 392.64-0.87Q395.60-3.07 399.36-3.07Q403.12-3.07 405.48-0.95Q407.84 1.17 407.84 5.05Q407.84 8.93 406.08 11.01Q404.32 13.09 400.68 13.09Q397.04 13.09 395.32 10.69Q393.60 8.29 394.88 4.05L394.88 4.05L397.76 4.05Q399.76-0.03 396.08-0.03",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.568421s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "39.76px -1.53px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.12-0.83L409.12-2.27L428.40-2.27L428.40 5.09Q429.68 1.41 432.32-0.83Q434.96-3.07 440.32-3.07L440.32-3.07Q452.72-3.07 452.72 10.29L452.72 10.29L452.72 34.37L457.20 34.37L457.20 35.81L434.56 35.81L434.56 34.37L437.84 34.37L437.84 8.37Q437.84 3.57 437.20 2.17Q436.56 0.77 434.88 0.77L434.88 0.77Q432.32 0.77 430.36 4.13Q428.40 7.49 428.40 12.29L428.40 12.29L428.40 34.37L431.84 34.37L431.84 35.81L409.12 35.81L409.12 34.37L413.52 34.37L413.52-0.83L409.12-0.83",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.505263s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "84.25px -1.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.28 36.61Q468.96 36.61 463.80 31.29Q458.64 25.97 458.64 16.49Q458.64 7.01 464.44 1.97Q470.24-3.07 479.20-3.07L479.20-3.07Q497.36-3.07 496.64 15.17L496.64 15.17L474.08 15.17L474.08 18.29Q474.08 26.13 476.08 30.13Q478.08 34.13 483.04 34.13L483.04 34.13Q492.32 34.13 495.20 24.21L495.20 24.21L496.64 24.45Q495.12 30.21 491.16 33.41Q487.20 36.61 479.28 36.61L479.28 36.61 zM474.16 9.65L474.16 13.57L482.40 13.57L482.40 9.65Q482.40 3.17 481.64 0.81Q480.88-1.55 478.60-1.55Q476.32-1.55 475.24 0.97Q474.16 3.49 474.16 9.65L474.16 9.65",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.442105s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "125.36px -1.53px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.24-0.03L526.24-0.03Q523.28-0.03 521.04 3.81Q518.80 7.65 518.80 12.93L518.80 12.93L518.80 34.37L524.48 34.37L524.48 35.81L499.52 35.81L499.52 34.37L503.92 34.37L503.92-0.83L499.52-0.83L499.52-2.27L518.80-2.27L518.80 5.41Q519.84 1.33 522.80-0.87Q525.76-3.07 529.52-3.07Q533.28-3.07 535.64-0.95Q538 1.17 538 5.05Q538 8.93 536.24 11.01Q534.48 13.09 530.84 13.09Q527.20 13.09 525.48 10.69Q523.76 8.29 525.04 4.05L525.04 4.05L527.92 4.05Q529.92-0.03 526.24-0.03",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.378947s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "188.72px -10.09px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.84 6.85L609.84 6.85Q609.84 23.33 600.56 29.81L600.56 29.81Q592 35.81 577.04 35.81L577.04 35.81L554.40 35.81L554.40 34.29L559.68 34.29L559.68-18.67L554.40-18.67L554.40-20.19L579.12-20.19Q594.48-20.19 602.16-13.91Q609.84-7.63 609.84 6.85 zM575.28-18.67L575.28 34.29L578.32 34.29Q586.40 34.29 589.88 28.57Q593.36 22.85 593.36 9.41L593.36 9.41L593.36 4.77Q593.36-13.23 586.48-16.91L586.48-16.91Q583.20-18.67 577.20-18.67L577.20-18.67L575.28-18.67",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.315789s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "242.08px -1.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.72 17.01L632.72 17.01L635.04 17.01L635.04 10.85Q635.04 3.25 634.20 0.65Q633.36-1.95 630.96-1.95L630.96-1.95Q629.52-1.95 628.36-1.19Q627.20-0.43 627.20 0.89Q627.20 2.21 627.68 3.57L627.68 3.57L629.68 3.57Q630.32 5.25 630.32 7.61Q630.32 9.97 628.32 11.69Q626.32 13.41 623.28 13.41L623.28 13.41Q616.40 13.41 616.40 6.77L616.40 6.77Q616.40-3.07 633.12-3.07L633.12-3.07Q642.64-3.07 646.28 0.17Q649.92 3.41 649.92 12.05L649.92 12.05L649.92 28.29Q649.92 32.45 652.24 32.45L652.24 32.45Q654.96 32.45 655.44 24.21L655.44 24.21L656.64 24.29Q656.32 31.33 654 33.97Q651.68 36.61 646.40 36.61L646.40 36.61Q636.80 36.61 635.36 30.69L635.36 30.69Q634.32 33.73 632.24 35.17Q630.16 36.61 626.16 36.61L626.16 36.61Q614.32 36.61 614.32 26.93L614.32 26.93Q614.32 21.25 618.84 19.13Q623.36 17.01 632.72 17.01 zM629.52 26.85Q629.52 31.01 629.96 32.21Q630.40 33.41 631.64 33.41Q632.88 33.41 633.96 31.37Q635.04 29.33 635.04 25.73L635.04 25.73L635.04 18.29L634.48 18.29Q629.52 18.29 629.52 25.57L629.52 25.57L629.52 26.85",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.252632s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "278px -7.74px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.24 24.37L660.24 24.37L660.24-0.83L655.84-0.83L655.84-2.27L660.24-2.27L660.24-12.59L675.12-16.27L675.12-2.27L685.52-2.27L685.52-0.83L675.12-0.83L675.12 26.13Q675.12 29.89 675.88 31.65Q676.64 33.41 679.04 33.41Q681.44 33.41 683.24 31.01Q685.04 28.61 685.60 24.45L685.60 24.45L686.96 24.61Q686.32 30.13 683.44 33.37Q680.56 36.61 673.92 36.61Q667.28 36.61 663.76 33.97Q660.24 31.33 660.24 24.37",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.189474s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "316.32px -1.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.96 17.01L706.96 17.01L709.28 17.01L709.28 10.85Q709.28 3.25 708.44 0.65Q707.60-1.95 705.20-1.95L705.20-1.95Q703.76-1.95 702.60-1.19Q701.44-0.43 701.44 0.89Q701.44 2.21 701.92 3.57L701.92 3.57L703.92 3.57Q704.56 5.25 704.56 7.61Q704.56 9.97 702.56 11.69Q700.56 13.41 697.52 13.41L697.52 13.41Q690.64 13.41 690.64 6.77L690.64 6.77Q690.64-3.07 707.36-3.07L707.36-3.07Q716.88-3.07 720.52 0.17Q724.16 3.41 724.16 12.05L724.16 12.05L724.16 28.29Q724.16 32.45 726.48 32.45L726.48 32.45Q729.20 32.45 729.68 24.21L729.68 24.21L730.88 24.29Q730.56 31.33 728.24 33.97Q725.92 36.61 720.64 36.61L720.64 36.61Q711.04 36.61 709.60 30.69L709.60 30.69Q708.56 33.73 706.48 35.17Q704.40 36.61 700.40 36.61L700.40 36.61Q688.56 36.61 688.56 26.93L688.56 26.93Q688.56 21.25 693.08 19.13Q697.60 17.01 706.96 17.01 zM703.76 26.85Q703.76 31.01 704.20 32.21Q704.64 33.41 705.88 33.41Q707.12 33.41 708.20 31.37Q709.28 29.33 709.28 25.73L709.28 25.73L709.28 18.29L708.72 18.29Q703.76 18.29 703.76 25.57L703.76 25.57L703.76 26.85",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.126316s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "348.08px 11.74px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.40 36.61Q737.92 36.61 736.20 34.57Q734.48 32.53 734.48 29.61Q734.48 26.69 736.28 24.69Q738.08 22.69 741.36 22.69Q744.64 22.69 746.56 24.37Q748.48 26.05 748.48 29.41Q748.48 32.77 746.68 34.69Q744.88 36.61 741.40 36.61",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear -0.0631579s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "369.28px 11.74px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.60 36.61Q759.12 36.61 757.40 34.57Q755.68 32.53 755.68 29.61Q755.68 26.69 757.48 24.69Q759.28 22.69 762.56 22.69Q765.84 22.69 767.76 24.37Q769.68 26.05 769.68 29.41Q769.68 32.77 767.88 34.69Q766.08 36.61 762.60 36.61",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      animation: "1.81818s linear 0s infinite normal forwards running animate-g2jinkib42l",
      transformBox: "view-box",
      transformOrigin: "390.48px 11.74px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.80 36.61Q780.32 36.61 778.60 34.57Q776.88 32.53 776.88 29.61Q776.88 26.69 778.68 24.69Q780.48 22.69 783.76 22.69Q787.04 22.69 788.96 24.37Q790.88 26.05 790.88 29.41Q790.88 32.77 789.08 34.69Q787.28 36.61 783.80 36.61",
    style: {
      fill: "rgb(0, 38, 66)"
    },
    transform: "translate(-393.400,-17.905)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    dy: "0.35em",
    fill: "#002642",
    fontFamily: "Abril Fatface",
    fontSize: 22
  }, "Supply Corner Data...")))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@keyframes animate-g2jinkib42l { 0.00% {animation-timing-function: cubic-bezier(0.33,0.00,0.67,0.00);transform: translate(0.00px,0.00px) rotate(0.00deg) scale(1.00, 1.00) skew(0deg, 0.00deg) ;opacity: 1.00;}48.00% {transform: translate(0.00px,0.00px) rotate(0.00deg) ;opacity: 1.00;}50.00% {animation-timing-function: cubic-bezier(0.33,0.00,0.67,0.00);transform: translate(0.00px,0.00px) rotate(0.00deg) ;opacity: 0.00;}100.00% {animation-timing-function: cubic-bezier(0.33,0.00,0.67,0.00);transform: translate(0.00px,0.00px) rotate(0.00deg) ;opacity: 0.00;} }")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyCornerDataLoader);
export default __webpack_public_path__ + "static/media/supply_corner_data_loader.45f009390b9ce983fe3376d2b57d7d5b.svg";
export { ForwardRef as ReactComponent };